/* unplugin-vue-components disabled */import script from "./module.vue?vue&type=script&setup=true&lang=js"
export * from "./module.vue?vue&type=script&setup=true&lang=js"

import "./module.vue?vue&type=style&index=0&id=2a67b6e4&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a67b6e4"]])

export default __exports__